import { render, staticRenderFns } from "./v-iframe-sandbox.vue?vue&type=template&id=17ab23b8&"
import script from "./v-iframe-sandbox.vue?vue&type=script&lang=js&"
export * from "./v-iframe-sandbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports